import React from 'react';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";

export default function ReflectAndIntegrate1({ apiData, previewData, reportType, pageNumber }) {
  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)", }}>
      <HeaderPreview apiData={apiData} />
      <div
        style={{
          margin: 'auto',
          overflowY: 'auto',
          fontFamily: 'Helvetica, sans-serif',
          color: '#245775',
          padding: "16px 0px"
        }}
      >
        <h2
          style={{
            fontFamily: 'Helvetica, sans-serif',
            fontWeight: 700,
            fontStyle: 'normal',
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: '0px',
            color: '#00577D',
            textTransform: 'uppercase',
            marginBottom: '16px',
            marginTop: 0,
          }}
        >
          REFLECT & INTEGRATE
        </h2>
        <p
          style={{
            fontFamily: 'Helvetica, sans-serif',
            fontWeight: 400,
            fontStyle: 'normal',
            fontSize: '10px',
            lineHeight: '14px',
            letterSpacing: '0px',
            color: '#000000',
            marginTop: 0,
            marginBottom: '16px',
          }}
        >
          As you review the results of your assessment, take time to answer some of the following questions to
          deepen your understanding and move your insights toward depth and action. These questions are designed
          to help you align your results with the life and leadership you want, need, and desire.
        </p>
        {/* Section 1 */}
        <div>
          <h3
            style={{
              fontSize: '10px',
              fontWeight: 700,
              color: '#000000',
              fontFamily: 'Helvetica, sans-serif',
              lineHeight: '14px',
              margin: "0px",
            }}
          >
            1. Assessments are a starting point, not the destination.
          </h3>
          <p
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 400,
              fontStyle: 'normal',
              fontSize: '10px',
              lineHeight: '14px',
              letterSpacing: '0px',
              color: '#000000',
              margin: "0px 0px 16px"

            }}
          >
            Your results offer a snapshot of where you are today—not a fixed label. They’re often relative to your current context, mindset, and season. Use them as a launchpad, not a verdict. Let them guide your next steps toward clarity and growth.
          </p>
        </div>
        {/* Section 2 */}
        <div>
          <h3
            style={{
              fontSize: '10px',
              fontWeight: 700,
              color: '#000000',
              fontFamily: 'Helvetica, sans-serif',
              lineHeight: '14px',
              margin: "0px"
            }}
          >
            2. Focus on progress, not perfection.
          </h3>
          <p
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 400,
              fontStyle: 'normal',
              fontSize: '10px',
              lineHeight: '14px',
              letterSpacing: '0px',
              color: '#000000',
              margin: "0px 0px 16px"
            }}
          >
            You’ll see strengths and stretch areas in your results. That’s expected. Keep your focus on movement, not mastery. Real leadership is built one intentional choice at a time.
          </p>
        </div>
        {/* Section 3 */}
        <div>
          <h3
            style={{
              fontSize: '10px',
              fontWeight: 700,
              color: '#000000',
              fontFamily: 'Helvetica, sans-serif',
              lineHeight: '14px',
              margin: "0px"
            }}
          >
            3. Integration is what creates change.
          </h3>
          <p
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 400,
              fontStyle: 'normal',
              fontSize: '10px',
              lineHeight: '14px',
              letterSpacing: '0px',
              color: '#000000',
              margin: "0px 0px 16px"
            }}
          >
            Insight alone doesn’t transform anything. Growth happens when new awareness shows up in your habits, relationships, and decisions.
          </p>
        </div>
        {/* Section 4 */}
        <div>
          <h3
            style={{
              fontSize: '10px',
              fontWeight: 700,
              color: '#000000',
              fontFamily: 'Helvetica, sans-serif',
              lineHeight: '14px',
              margin: "0px"
            }}
          >
            4. Growth is a team sport.
          </h3>
          <p
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 400,
              fontStyle: 'normal',
              fontSize: '10px',
              lineHeight: '14px',
              letterSpacing: '0px',
              color: '#000000',
              margin: "0px 0px 16px"
            }}
          >
            Don’t go it alone. Share your results with a coach, mentor, or trusted peer. Outside perspective brings clarity, challenge, and support.
          </p>
        </div>
        {/* Section 5 */}
        <div>
          <h3
            style={{
              fontSize: '10px',
              fontWeight: 700,
              color: '#000000',
              fontFamily: 'Helvetica, sans-serif',
              lineHeight: '14px',
              margin: "0px"
            }}
          >
            5. Stay open and agile.
          </h3>
          <p
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 400,
              fontStyle: 'normal',
              fontSize: '10px',
              lineHeight: '14px',
              letterSpacing: '0px',
              color: '#000000',
              margin: "0px 0px 16px"
            }}
          >
            Leadership is dynamic. Your context will change. So will your needs. Revisit your results often, stay flexible, and keep adjusting as you grow.
          </p>
        </div>
        <div>
          <h3
            style={{
              fontSize: '10px',
              fontWeight: 700,
              color: '#000000',
              fontFamily: 'Helvetica, sans-serif',
              lineHeight: '14px',
              margin: "0px"
            }}
          >
            6. Own your development.
          </h3>
          <p
            style={{
              fontFamily: 'Helvetica, sans-serif',
              fontWeight: 400,
              fontStyle: 'normal',
              fontSize: '10px',
              lineHeight: '14px',
              letterSpacing: '0px',
              color: '#000000',
              margin: "0px 0px 16px"
            }}
          >
            No one can grow for you. This assessment gave you language—what you do with it is up to you. Ownership turns potential into transformation.
          </p>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
}
